import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { trackEvent } from "../../utils/tracking";
import { TRACKING_EVENTS } from "../../utils/trackingDefinitions";

export const LoginLink = (props) => {
	const returnUrl = useSelector(
		(state) => state.registration[`${props.form}`].form.returnUrl,
	);

	const email = useSelector(
		(state) => state.registration[`${props.form}`].form.email,
	);

	const handleRedirectToLogin = () => {
		trackEvent({
			event: TRACKING_EVENTS.COMMON.EVENT.USER_INTERACTION,
			target: TRACKING_EVENTS.REGISTRATION.APP,
			key: "action",
			value: TRACKING_EVENTS.COMMON.EVENT.REDIRECT_TO_LOGIN,
		});

		window.location.href = `/login/local?returnUrl=${encodeURIComponent(
			returnUrl,
		)}&username=${encodeURIComponent(email)}`;
	};

	return (
		<a href="#" onClick={handleRedirectToLogin}>
			<FormattedMessage id="komid.register.validation.username.exists.login.link" />
		</a>
	);
};
